import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RewardLayer from "../components/RewardLayer";

const RewardPage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="Rewards Configuration" />

                    <RewardLayer />
               </MasterLayout>
          </>
     );
};

export default RewardPage;
